export default __webpack_public_path__ + "static/media/George Brown College.jpg.937fea95.png";